import { count } from "console";
import { ComputePercent } from "../../../../shared/scripts/number-functions";

export class ExecutiveSummaryEntry {
    Id: number;
    Group: string;
    Label: string;
    Type: number; //0: main row (no children), 1: main row (with children), 2: child row, 3: header row
    OrderBy: number;
    ParentId: number;
    Counts: number[] = [];
    Indent: number;

    ParentHash: string; //assumes a single nesting by GROUP
    HasChildren: boolean;
    IsLastChild: boolean;

    DisplayValues: string[] = [];

    TrialColumn = 0;
    TotalColumn = 1;

    initialize(): void {
        if (this.Type == 3) { this.Counts = [-1, -1]; }
        else {
            this.Counts[this.TotalColumn] = this.Counts[this.TrialColumn];
        }
        this.DisplayValues = this.Counts.map((count: number) =>
            count === -1 ? "" : count.toLocaleString()
        );
    }

    createDisplayValues(parentEntry: ExecutiveSummaryEntry): void {
        this.DisplayValues = this.Counts.map((count: number, index: number) => {
            if (count === -1 || parentEntry.Counts[index] === -1) return "";
            const percent = ComputePercent(count, parentEntry.Counts[index]);
            if (percent >= 0) {
                return count.toLocaleString() + " (" + percent.toFixed(0) + "%)";
            }
            else return count.toLocaleString() + "";
        })
    }
}